import { Button } from "@mui/material";
import { type FC, useState } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import toast from "react-hot-toast";
import { useApiServiceCallback } from "../../../../server/api/client";
import { MomentService } from "../../client";
import type { MomentFormMoment } from "../../types/moment-form-moment";

export const PauseButton: FC<{
  saving: boolean;
  formDisabled: boolean;
  onPaused?: () => void;
}> = ({ saving, formDisabled, onPaused }) => {
  const { control, setValue, getValues } = useFormContext<MomentFormMoment>();
  const [pausing, setPausing] = useState(false);
  useWatch({ control, name: ["id"] });
  const [momentId] = getValues(["id"]);

  const handlePause = useApiServiceCallback(
    MomentService,
    async ({ apiService }) => {
      setPausing(true);
      const { error } = await apiService.setActiveStatus(momentId, false, false);
      if (error) toast.error(error);
      else {
        toast.success("Communication Paused.");
        onPaused?.();
      }
      setValue("running", !!error, { shouldDirty: true });
      setPausing(false);
    },
    [momentId],
  );

  return (
    <Button
      data-analytics-id="moment-form-pause"
      disabled={formDisabled}
      loading={saving || pausing}
      variant="contained"
      onClick={() => void handlePause().catch(console.error)}
      sx={{ ml: 1 }}
    >
      Pause and Edit
    </Button>
  );
};
